import axios from 'axios';

export class HttpServiceWithoutCredentials {
    constructor () {
        this.axios = axios.create();

        this.interceptors = {
            request: this.axios.interceptors.request,
            response: this.axios.interceptors.response
        };

        this.axios.interceptors.request.use(
            (config) => {
                return Promise.resolve(config);
            },
            (error) => {
                return Promise.reject(error);
            }
        );
    }

    get (url, params) {
        return this.axios.get(url, params);
    }

    post (url, data) {
        return this.axios.post(url, data);
    }

    postWithHeaders (url, data, headers) {
        return this.axios.post(url, data, headers);
    }

    put (url, data) {
        return this.axios.put(url, data);
    }

    delete (url, params) {
        return this.axios.delete(url, params);
    }
}

export default new HttpServiceWithoutCredentials();
